module.exports = "<div class=\"bodywrap clearfix\">\r\n\r\n    <div class=\"error-template\">\r\n        <h1>Oops!</h1>\r\n        <h2>401 Not Authorized</h2>\r\n        <div class=\"error-details\">\r\n            You are not authorized to view this page!<br>\r\n        </div>\r\n    </div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/unauthorized.component.html
// module id = ./src/app/core/unauthorized.component.html
// module chunks = main